import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import qs from "query-string";

import {getCookie} from "@pg-mono/request";

import {convertHeaderRelativeInput} from "../utils/convert_header_relative_input";

export const rpApi = createApi({
    reducerPath: "rpApi",
    baseQuery: fetchBaseQuery({
        baseUrl: "/",
        credentials: "include",
        paramsSerializer: qs.stringify,
        prepareHeaders: (headers, api) => {
            const customCsrfToken = headers.get("X-CSRFToken");
            const csrf = getCookie("csrftoken");

            if (api.type === "mutation") {
                headers.set("Content-Type", "application/json");
            }

            if (api.type === "mutation" && !customCsrfToken && csrf) {
                headers.set("X-CSRFToken", csrf);
            }

            return headers;
        },
        fetchFn: (input, init) => {
            const stageInput = convertHeaderRelativeInput(input);
            return fetch(stageInput, init);
        }
    }),
    endpoints: () => ({}),
    tagTypes: ["RpPropertiesList"]
});
import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import qs from "query-string";

import {getCookie} from "@pg-mono/request";

import {convertHeaderRelativeInput} from "../utils/convert_header_relative_input";

export const rpApi = createApi({
    reducerPath: "rpApi",
    baseQuery: fetchBaseQuery({
        baseUrl: "/",
        credentials: "include",
        paramsSerializer: qs.stringify,
        prepareHeaders: (headers, api) => {
            const customCsrfToken = headers.get("X-CSRFToken");
            const csrf = getCookie("csrftoken");

            if (api.type === "mutation") {
                headers.set("Content-Type", "application/json");
            }

            if (api.type === "mutation" && !customCsrfToken && csrf) {
                headers.set("X-CSRFToken", csrf);
            }

            return headers;
        },
        fetchFn: (input, init) => {
            const stageInput = convertHeaderRelativeInput(input);
            return fetch(stageInput, init);
        }
    }),
    endpoints: () => ({}),
    tagTypes: ["RpPropertiesList"]
});
